import { USERS_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/login`,
                method: 'POST',
                body: data
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${USERS_URL}/logout`,
                method: 'POST'
            })
        }),
        updateProfile: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/profile`,
                method: 'PUT',
                body: data
            })
        }),
        getUserProfile: builder.query({
            query: () => ({
                url: `${USERS_URL}/profile`,
                method: 'GET'
            }),
            keepUnusedDataFor: 5
        }),
        getUsers: builder.query({
            query: () => ({
                url: USERS_URL,
                method: 'GET'
            }),
            providesTags: ['User'],
            keepUnusedDataFor: 5
        }),
        updateUser: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/${data.userId}`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['User']
        })
    })
});

export const {
    useLoginMutation, 
    useLogoutMutation, 
    useUpdateProfileMutation,
    useGetUserProfileQuery,
    useGetUsersQuery,
    useUpdateUserMutation
} = usersApiSlice;
